import { createContext, useContext } from 'react';

export const MapMonitorContext = createContext(null);

export function useMapMonitor() {
  return useContext(MapMonitorContext);
}